import React, { useEffect, useState } from 'react';
import './NavigationBar.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useLocation } from 'react-router-dom';
import samplelogo from '../images/seal1.png';

const NavigationBar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
    setShowSubMenu(false);
  };

  const toggleSubMenu = () => {
    setShowSubMenu(!showSubMenu);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light fixed-top">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src={samplelogo} alt="Seal-Active Logo" className="navbar-logo" />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          onClick={handleToggle}
          aria-controls="navbarNav"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav mx-auto">
            <li className="nav-item">
              <Link
                className="nav-link"
                to="/"
                onClick={handleLinkClick}
                style={{ padding: '20px', fontSize: '1.2rem' }}
              >
                Home
              </Link>
            </li>

            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                onClick={toggleSubMenu}
                style={{ cursor: 'pointer', padding: '20px', fontSize: '1.2rem' }}
              >
                Products
              </span>
              {showSubMenu && (
                <ul className="dropdown-menu show">
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/hot-melt-adhesive"
                      onClick={handleLinkClick}
                    >
                      Hot Melt Adhesive
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/water-based-adhesive"
                      onClick={handleLinkClick}
                    >
                      Water Based Adhesive
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li className="nav-item">
              <Link
                className="nav-link"
                to="/choose-us"
                onClick={handleLinkClick}
                style={{ padding: '20px', fontSize: '1.2rem' }}
              >
                Why Us?
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                to="/vision"
                onClick={handleLinkClick}
                style={{ padding: '20px', fontSize: '1.2rem' }}
              >
                Our Vision
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                to="/about-us"
                onClick={handleLinkClick}
                style={{ padding: '20px', fontSize: '1.2rem' }}
              >
                About Us
              </Link>
            </li>
          </ul>
          <div className="d-flex justify-content-center">
            <Link
              to="/contact-us"
              className="btn btn-jatayu"
              onClick={handleLinkClick}
              style={{ backgroundColor: 'black', color: 'white' }}
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavigationBar;
